import { NamedEntityDto } from "approot/global/models/common.model";
import { AlertsService } from "approot/global/providers/uikit.alerts";
import { Select2AjaxSource, Select2Config } from "approot/global/ui-components/select2.directive";
import { SchoolSearchInfo } from "../loginform.component";

declare let angular: ng.IAngularStatic;

export interface InitSelect2Info {
	selectName: string;
	selectItem: NamedEntityDto
}

export class LoginSelect2ConfigService {
	private defaultSettings: Select2Config;
	private defaultAjaxSettings: Select2AjaxSource;

	/*@ngInject*/
	constructor(
		private $alerts: AlertsService,
		private language: any
	) {
		this.defaultSettings = {
			limit: 20,
			minimumInputLength: 2,
			language: "ru",
			allowClear: true,
			width: 'resolve',
			dropdownAutoWidth: false,
		};

		this.defaultAjaxSettings = {
			url: null,
			delay: 250,
			cache: true,
			type: "GET",
			dataType: "json",
			escapeMarkup: (markup) => markup,
			traditional: true,
			params: {
				contentType: "application/json"
			},
			data: (params) => {
				let nameParts = params.term.split(" ").filter(i => i.length > 0);
				let query: any = {
					name: nameParts
				}
				return query;
			},
			transport: (params, success, failure) => {
				let $request = $.ajax(params);

				$request.then(success);
				$request.fail((jqXHR) => {
					if (jqXHR.statusText === "error") {
						this.$alerts.error(this.language.Generic.Messages.kErrorReceivingSelectData);
					}
					failure();
				});

				return $request;
			}
		};
	}

	configure(config: Select2Config): Select2Config {
		let select2Settings: Select2Config = Object.assign({}, this.defaultSettings, config);

		if (config.ajax) {
			select2Settings.ajax = Object.assign({}, this.defaultAjaxSettings, config.ajax);
		}

		return select2Settings;
	}

	displayOrgResult(item, container) {
		if (!String.prototype.escapeHTML) {
			String.prototype.escapeHTML = function(): string {
				return this
					.replace(/&/g, '&amp;')
					.replace(/</g, '&lt;')
					.replace(/>/g, '&gt;')
					.replace(/"/g, '&quot;')
					.replace(/'/g, '&#039;');
			};
		}
		const clonedItem = angular.copy(item)
		if(clonedItem.text) {
			clonedItem.text = (<string>clonedItem.text).escapeHTML()
		}
		if (!clonedItem.id) {
			return clonedItem.text;
		}

		let orgInfo: SchoolSearchInfo = clonedItem.obj as SchoolSearchInfo;

		// если в поиске больше 20 организаций
		if (orgInfo.id == -2) {
			let removedClasses = [];
			container.classList.forEach((c) => {
				if (c != "select2-results__option")
					removedClasses.push(c);
			});
			removedClasses.forEach(rc => container.classList.remove(rc));
			container.classList.add("select2-results__message");
			return $(`<span>${clonedItem.text}</span>`);
		}

		return $(`
			<div class="org-name-data">${clonedItem.text}</div>
			<div class="org-location-data">${orgInfo?.address ?? this.language.Generic.Messages.kAddressNotSpecified}</div>`
		);
	}

	private contentReady(): Promise<void> {
		return new Promise((resolve) => setTimeout(resolve, 50));
	}

	initSelection(initInfo: InitSelect2Info) {
		if (initInfo?.selectName == null || initInfo?.selectItem == null) {
			return;
		}

		let query = `select[name="${initInfo.selectName}"]`;
		let data: any = initInfo.selectItem;

		this.contentReady().then(() => {
			let select = angular.element(query);

			if (!select.length) {
				return;
			}

			let option = new Option(data.name || data.text, data.id.toString(), false, true);

			select.append(option).trigger("change.select2");

			(<any>select).trigger({
				type: "select2:select",
				params: { data: data }
			});
		});
	}

	initEvents() {
		// angular.element(document).ready(() => {
		// 	this.select2OpenEvent();
		// });
	}

	private select2OpenEvent() {
		angular.element(document).on("select2:open", (event) => {
			this.setSearchFocus();
		});
	}

	private setSearchFocus() {
		setTimeout(() => {
			let searchInp = angular.element(".select2-container--open .select2-search__field");
			if (searchInp && searchInp.length) {
				searchInp.get(0).focus();
			}
		}, 10);
	}
}